import Webb from "../attorneys/webb";

export default Webb;
